// Class
import { CartItem } from "../classes/CartItem";
import { CartTrackingData } from "../classes/CartTrackingData";

function buildCartTrackingData(
	quantity: number,
	prestIds: string[],
	prestNames: string[],
	itemPriceAti: string,
	beginDate: string,
	endDate: string,
	duration: number
): CartTrackingData {
	if (typeof quantity === "undefined")
		throw new Error("quantity is mandatory in buildCartTrackingData");
	if (!prestIds || !prestIds.length)
		throw new Error("prestIds is mandatory in buildCartTrackingData");
	if (!prestNames || !prestNames.length)
		throw new Error("prestNames is mandatory in buildCartTrackingData");
	if (typeof itemPriceAti === "undefined")
		throw new Error("itemPriceAti is mandatory in buildCartTrackingData");

	if (typeof beginDate === "undefined")
		throw new Error("beginDate is mandatory in buildCartTrackingData");
	if (typeof endDate === "undefined")
		throw new Error("endDate is mandatory in buildCartTrackingData");
	if (typeof duration === "undefined")
		throw new Error("duration is mandatory in buildCartTrackingData");
	const cartTrackingItem = new CartItem(
		quantity,
		prestIds,
		prestNames,
		itemPriceAti,
		beginDate,
		endDate,
		`${duration} days`
	);

	const ecommerce = {
		items: [cartTrackingItem],
	};

	const cartTrackingData = new CartTrackingData(ecommerce);
	return cartTrackingData;
}

export default buildCartTrackingData;
